<template>
  <label class="custom-toggle">
    <input type="checkbox" :checked="modelValue" v-bind="$attrs" @input="onInput"/>
    <span class="custom-toggle-slider rounded-circle"></span>
  </label>
</template>
<script>
export default {
  name: "base-switch",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      description: "Switch value",
    },
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    onInput(evt) {
      this.$emit("update:modelValue",  evt.target.checked);
    }
  } 
  
};
</script>
<style></style>
